var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 232.525,
    height: 196.359,
    viewBox: "0 0 232.525 196.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.j,.l{fill:#fef4d9;}.a{clip-rule:evenodd;}.b,.t{fill:#48d1cc;}.b,.c,.d,.e,.f,.i,.j{fill-rule:evenodd;}.c{fill:#191350;}.d,.h,.i{fill:#4b4495;}.e,.v{fill:#fff;}.f{fill:#dbdaea;}.g,.i{mix-blend-mode:multiply;isolation:isolate;}.k{clip-path:url(#a);}.m{clip-path:url(#b);}.n{clip-path:url(#c);}.o{clip-path:url(#d);}.p{clip-path:url(#e);}.q{fill:#f6e2bb;}.r{fill:#d2a96f;}.s{fill:#e7c798;}.u{fill:#423d7e;}.w{filter:url(#p);}.x{filter:url(#n);}.y{filter:url(#l);}.z{filter:url(#j);}.aa{filter:url(#h);}.ab{filter:url(#f);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M153.979,143.038l13.292-10.732,11.207-.089-6.445,11.416Z",
    transform: "translate(-153.979 -132.218)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M206.007,144.057l3.792-11.971,15.512-.053-1.539,12.352Z",
    transform: "translate(-206.007 -132.033)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M257.756,144.589l-.566-12.483,16.848-.058,1.572,12.541Z",
    transform: "translate(-257.19 -132.048)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M307.837,144.28l-4.331-12.568,15.116-.063,7.449,12.3Z",
    transform: "translate(-303.506 -131.649)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.711,143.4l-7.19-11.9,13.138-.1,12.1,11.4Z",
    transform: "translate(-351.521 -131.393)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 6.44,
    y: 1.139,
    width: 31.2,
    height: 32.421,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 13.277,
    y: 1.023,
    width: 32.264,
    height: 32.381,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 20.469,
    y: 0.898,
    width: 32.264,
    height: 32.395,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 28.557,
    y: 0.829,
    width: 30.672,
    height: 32.279,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 35.026,
    y: 0,
    width: 32.069,
    height: 33.061,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 137.639,
    y: 73.866,
    width: 94.886,
    height: 122.492,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "q"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#39beb9",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-90.522 -222.593)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 -62)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.354 -42.343)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.876 328.039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.108 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M301.841,91.11l1.889,18.472h.71L302.711,91.11Z",
    transform: "translate(-298.368 -70.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M364.612,91.123l-2.307,18.536-.474.014,2.034-18.564Z",
    transform: "translate(-329.981 -70.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M332.139,109.625l.072,9.216h.631l.136-9.216Z",
    transform: "translate(-314.334 -79.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M295.054,85.971,297,87.383l10.119.342.548,7.1,1.632,1.651,7.726.114,1.709-1.765.673-6.973,10.39-.469,2.306-1.412-24.049-3.138Z",
    transform: "translate(-294.792 -65.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M331.811,57.282H320.225l.979-10.148a67.815,67.815,0,0,0-16.037,0l.783,10.148H294.5l.262,9.625h11.929l.683,8.854h11.068l.854-8.854h12.515Z",
    transform: "translate(-294.5 -46.657)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M305.446,131.7l-2.5,78.29-.881,27.55c-.106,2.956-1.974,5.29-4.238,5.29H151.414c-2.291,0-4.165-2.369-4.245-5.351l-2.583-105.849c-.086-3.129,1.841-5.739,4.238-5.739H301.208C303.632,125.892,305.559,128.537,305.446,131.7Z",
    transform: "translate(-125.74 -85.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M153.64,133.051l1.278,97.8,143.675-.189,2.634-98.013Z",
    transform: "translate(-127.509 -87.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M148.586,257.5v-2.428L329.27,253.9l-.151,3.66s.048,4.9-4.946,5.29H153.534A5.339,5.339,0,0,1,148.586,257.5Z",
    transform: "translate(-140.085 -105.322)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(107.478 94.863)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 27.345,
    height: 1.913,
    transform: "translate(0 7.208)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 41.259,
    height: 1.913,
    transform: "translate(0 10.723)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 27.345,
    height: 1.913,
    transform: "translate(0 3.833)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.403,
    height: 1.913
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 3.501,
    height: 1.913,
    transform: "translate(29.091 7.094)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.403,
    height: 1.913,
    transform: "translate(18.482)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M300.644,224.638v7.85H334.3l.464-7.85Z",
    transform: "translate(-193.165 -110.652)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 38.19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M146.98,170.116l154.54,2.228,1-24.309-156.427,7.942Z",
    transform: "translate(-127.249 -140.166)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M138.916,163.4h0c-4.893,0-9.239-2.909-9.709-6.5l-1.329-10.167h18.128l1.08,10.167C147.466,160.487,143.809,163.4,138.916,163.4Z",
    transform: "translate(-127.878 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M164.5,163.4h0c-4.893,0-9.168-2.909-9.549-6.5l-1.08-10.167H172l.83,10.167C173.124,160.487,169.394,163.4,164.5,163.4Z",
    transform: "translate(-135.745 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M190.087,163.4h0c-4.893,0-9.1-2.909-9.389-6.5l-.83-10.167H198l.58,10.167C198.781,160.487,194.98,163.4,190.087,163.4Z",
    transform: "translate(-143.612 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M215.673,163.4h0c-4.893,0-9.025-2.909-9.23-6.5l-.58-10.167H223.99l.331,10.167C224.437,160.487,220.565,163.4,215.673,163.4Z",
    transform: "translate(-151.478 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M241.258,163.4h0c-4.893,0-8.954-2.909-9.07-6.5l-.331-10.167h18.128l.081,10.167C250.094,160.487,246.151,163.4,241.258,163.4Z",
    transform: "translate(-159.345 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M266.843,163.4h0c-4.893,0-8.882-2.909-8.91-6.5l-.081-10.167H275.98l-.169,10.167C275.751,160.487,271.736,163.4,266.843,163.4Z",
    transform: "translate(-167.212 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M292.355,163.4h0c-4.893,0-8.811-2.909-8.751-6.5l.169-10.167H301.9l-.419,10.167C301.334,160.487,297.248,163.4,292.355,163.4Z",
    transform: "translate(-175.005 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M317.831,163.4h0c-4.893,0-8.739-2.909-8.592-6.5l.419-10.167h18.127l-.669,10.167C326.881,160.487,322.724,163.4,317.831,163.4Z",
    transform: "translate(-182.762 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M343.305,163.4h0c-4.893,0-8.668-2.909-8.433-6.5l.669-10.167h18.128l-.918,10.167C352.427,160.487,348.2,163.4,343.305,163.4Z",
    transform: "translate(-190.518 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M368.778,163.4h0c-4.893,0-8.6-2.909-8.272-6.5l.918-10.167h18.128L378.384,156.9C377.972,160.487,373.671,163.4,368.778,163.4Z",
    transform: "translate(-198.272 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M394.25,163.4h0c-4.893,0-8.525-2.909-8.112-6.5l1.168-10.167h18.128L404.015,156.9C403.515,160.487,399.142,163.4,394.25,163.4Z",
    transform: "translate(-206.025 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M146.146,132.071,127.878,142.09c73.789,3,123.758,3.13,199.408,0l-19.058-10.7Z",
    transform: "translate(-127.878 -131.392)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.202 0.576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24.499,
    height: 11.416
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.487v2.542H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.471v2.557H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.455v2.573H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.439v2.589H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.423v2.605H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.407v2.621H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.391v2.637H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.376v2.653H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.36v2.669H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.344v2.685H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.328v2.7H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.312v2.716H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.3v2.732H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.28v2.748H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.264v2.764H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.249v2.78H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.233v2.8H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M178.873,141.217v2.812H152.979v-12.81h25.894Z",
    transform: "translate(-153.677 -131.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M179.087,141.007v2.828H154.08v.842a26.845,26.845,0,0,1-.393-4.751,27.42,27.42,0,0,1,1.728-9.348v.446h23.672Z",
    transform: "translate(-153.891 -131.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M180.134,141.118v2.844H157.527v.719a26.076,26.076,0,0,1-.38-4.611A26.6,26.6,0,0,1,158.823,131v.155h21.311Z",
    transform: "translate(-154.938 -131.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M181.181,139.416v2.859H160.974v.595a25.292,25.292,0,0,1-.369-4.472,25.792,25.792,0,0,1,1.626-8.8,29.634,29.634,0,0,1,1.93-4.176v4.04h17.021Z",
    transform: "translate(-155.984 -130.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M182.227,139.583v2.875h-16.7v4.682a24.727,24.727,0,0,1,.113-17.065,28.648,28.648,0,0,1,1.869-4.046v3.619h14.72Z",
    transform: "translate(-157.031 -130.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M183.274,139.75v2.891H168.936v4.423a23.928,23.928,0,0,1,.109-16.515,27.78,27.78,0,0,1,1.809-3.916v3.2h12.419Z",
    transform: "translate(-158.077 -130.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M184.32,139.917v2.907H172.347v4.163a23.135,23.135,0,0,1,.105-15.966,26.841,26.841,0,0,1,1.748-3.784v2.776h10.12Z",
    transform: "translate(-159.124 -130.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M185.367,140.084v2.923h-9.608v3.9a22.337,22.337,0,0,1,.1-15.414,25.86,25.86,0,0,1,1.688-3.654V130.2h7.819Z",
    transform: "translate(-160.171 -130.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.413,140.25v2.939H179.17v3.644a21.537,21.537,0,0,1,.1-14.864,24.98,24.98,0,0,1,1.628-3.524v1.933h5.518Z",
    transform: "translate(-161.217 -131.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M187.46,139.008v2.955H182.58v3.384a20.956,20.956,0,0,1-1.227-7.165,22.96,22.96,0,0,1,5.018-13.79v4.76h1.088Z",
    transform: "translate(-162.263 -129.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M188.507,139.229V142.2h-2.515v3.124a20.151,20.151,0,0,1-1.18-6.889,22.079,22.079,0,0,1,4.826-13.26l-1.131,4.214Z",
    transform: "translate(-163.31 -130.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M189.553,139.45v2.987H189.4V145.3a19.359,19.359,0,0,1-1.133-6.614,21.2,21.2,0,0,1,4.633-12.73l-3.349,3.668Z",
    transform: "translate(-164.357 -130.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.282v0Z",
    transform: "translate(-164.914 -136.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.26v0Z",
    transform: "translate(-164.914 -136.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.237v0Z",
    transform: "translate(-164.914 -136.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.214v0Z",
    transform: "translate(-164.914 -136.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.191v0Z",
    transform: "translate(-164.914 -136.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.168v0Z",
    transform: "translate(-164.914 -136.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.146v0Z",
    transform: "translate(-164.914 -136.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.123v0Z",
    transform: "translate(-164.914 -136.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.1v0Z",
    transform: "translate(-164.914 -136.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.077v0Z",
    transform: "translate(-164.914 -136.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.055v0Z",
    transform: "translate(-164.914 -136.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.032v0Z",
    transform: "translate(-164.914 -136.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,145.009v0Z",
    transform: "translate(-164.914 -136.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.986v0Z",
    transform: "translate(-164.914 -136.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.963v0Z",
    transform: "translate(-164.914 -136.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.941v0Z",
    transform: "translate(-164.914 -136.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.918v0Z",
    transform: "translate(-164.914 -136.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.895v0Z",
    transform: "translate(-164.914 -136.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.872v0Z",
    transform: "translate(-164.914 -136.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.85v0Z",
    transform: "translate(-164.914 -136.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.827v0Z",
    transform: "translate(-164.914 -136.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.8v0Z",
    transform: "translate(-164.914 -136.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.11,144.781v0Z",
    transform: "translate(-164.914 -136.02)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.485 0.447)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 19.304,
    height: 12.352
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,142.056v2.723h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,142.04v2.739h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,142.024v2.755h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,142.008v2.771h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.992v2.787h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.976v2.8h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.961v2.819h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.945v2.835h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.929v2.851h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.913v2.866h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.9v2.882h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.881v2.9h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.865v2.914h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.849v2.93h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.833v2.946h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.817v2.962h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.8v2.978h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.786v2.994h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.77v3.01h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.754v3.025h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.738v3.041h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.722v3.057h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.706v3.073h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.69v3.089h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.674v3.1h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.658v3.121h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.642v3.137h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.627v3.153h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.611v3.169h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.595v3.185h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.579v3.2h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.706,141.563v3.216h-20.7V131.033h20.7Z",
    transform: "translate(-205.705 -131.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M224.824,141.226v3.232h-20.7V140.59H202.09a17.683,17.683,0,0,1,3.864-10.618v.74h18.869Z",
    transform: "translate(-204.822 -131.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M225.871,141.447V144.7H206.449v1.388a15.316,15.316,0,0,1-.9-5.241,16.8,16.8,0,0,1,3.671-10.087v.193h16.648Z",
    transform: "translate(-205.869 -131.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M226.919,139.866v3.264H209.863v1.128a14.524,14.524,0,0,1-.85-4.965,15.908,15.908,0,0,1,3.478-9.555,25.078,25.078,0,0,1,4.034-4.154v3.8h10.394Z",
    transform: "translate(-206.917 -130.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M227.966,140.188v3.28H213.278v.868a13.708,13.708,0,0,1-.8-4.689,15.028,15.028,0,0,1,3.284-9.025,23.709,23.709,0,0,1,3.81-3.923v3.022h8.4Z",
    transform: "translate(-207.965 -130.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M229.014,140.51v3.3h-10.1v4.729a13.458,13.458,0,0,1,.112-17.028,22.317,22.317,0,0,1,3.585-3.693v2.245h6.4Z",
    transform: "translate(-209.012 -130.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M230.061,139.527v3.312H222.19v4.211a13.263,13.263,0,0,1-2.793-8c.038-5.663,4.124-10.763,10.7-14.431l-.037,4.473Z",
    transform: "translate(-210.059 -129.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M231.109,139.935v3.328h-5.643v3.694a12.373,12.373,0,0,1-2.607-7.467c.035-5.285,3.849-10.045,9.987-13.468l-1.737,3.5Z",
    transform: "translate(-211.107 -130.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M232.156,140.343v3.344H228.74v3.177a11.492,11.492,0,0,1-2.421-6.934c.033-4.907,3.574-9.327,9.274-12.506l-3.438,2.517Z",
    transform: "translate(-212.155 -130.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M233.2,141.8v3.36h-1.188v2.659a10.095,10.095,0,0,1,.084-12.771,16.744,16.744,0,0,1,2.689-2.769H233.2Z",
    transform: "translate(-213.202 -132.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.251,143.218v3.376l1.04,2.142a9.253,9.253,0,0,1,.077-11.707h-1.117Z",
    transform: "translate(-214.25 -133.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.882v0Z",
    transform: "translate(-214.687 -136.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.859v0Z",
    transform: "translate(-214.687 -136.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.836v0Z",
    transform: "translate(-214.687 -136.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.813v0Z",
    transform: "translate(-214.687 -136.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.791v0Z",
    transform: "translate(-214.687 -136.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.768v0Z",
    transform: "translate(-214.687 -136.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.745v0Z",
    transform: "translate(-214.687 -136.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.722v0Z",
    transform: "translate(-214.687 -136.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.7v0Z",
    transform: "translate(-214.687 -136.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M234.689,145.676v0Z",
    transform: "translate(-214.687 -136.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.178 0.457)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 18.42,
    height: 12.541
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.235v2.749H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.218v2.765H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.2v2.781H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.186v2.8H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.169v2.814H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.153v2.83H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.137v2.847H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.12v2.863H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.1v2.879H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.088v2.9H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.071v2.912H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.055v2.928H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.039v2.945H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.023v2.961H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,142.006v2.977H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.99v2.993H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.974v3.01H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.957v3.026H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.941v3.042H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.925v3.059H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.908v3.075H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.892v3.091H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.876v3.108H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.859v3.124H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.843v3.14H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.827v3.157H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.81v3.173H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.794v3.189H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.778v3.206H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.762v3.222H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.745v3.238H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.729v3.254H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.713v3.271H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.7v3.287H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.68v3.3H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.664v3.32H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.647v3.336H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.631v3.352H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.615v3.369H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.6v3.385H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.582v3.4H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.566v3.418H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.55v3.434H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276,141.533v3.45H256.19V131.048H276Z",
    transform: "translate(-256.887 -131.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M274.548,141.136V144.6H254.734v-11.62h-3.356a31.493,31.493,0,0,1,28.009.184h-4.839Z",
    transform: "translate(-255.431 -131.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M275.3,141.728v3.483H255.491V134.593h-1.612a27.553,27.553,0,0,1,24.508.161H275.3Z",
    transform: "translate(-256.188 -131.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M274.157,142.32v3.5h-9.273v4.815c-8.2-.054-14.83-3.864-14.8-8.51s6.706-8.369,14.909-8.315a21.735,21.735,0,0,1,10.488,2.533h-1.325Z",
    transform: "translate(-255.039 -132.581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 7.011,
    cy: 12.379,
    rx: 7.011,
    ry: 12.379,
    transform: "translate(-2.525 16.57) rotate(-89.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276.99,143.5c-.02,3.1-4.471,5.579-9.94,5.543s-9.886-2.576-9.866-5.674,4.471-5.579,9.94-5.543S277.01,140.407,276.99,143.5Z",
    transform: "translate(-257.188 -133.798)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 4.206,
    cy: 7.427,
    rx: 4.206,
    ry: 7.427,
    transform: "translate(2.445 13.799) rotate(-89.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M274.188,144.689c-.01,1.549-2.235,2.789-4.969,2.771s-4.944-1.288-4.933-2.837,2.235-2.789,4.969-2.771S274.2,143.14,274.188,144.689Z",
    transform: "translate(-259.337 -135.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M272.786,145.281c0,.775-1.118,1.395-2.485,1.386s-2.471-.644-2.467-1.418,1.118-1.395,2.485-1.386S272.791,144.507,272.786,145.281Z",
    transform: "translate(-260.411 -135.623)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.478 0.179)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 22.565,
    height: 12.631
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.964v2.711h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.948v2.727h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.932v2.743h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.916v2.759h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.9v2.775h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.884v2.791h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.868v2.807h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.852v2.823h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.836v2.839h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.82v2.855h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.8v2.871h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.788v2.887h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.772v2.9h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.756v2.919h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.74v2.935h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.724v2.951h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.708v2.966h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.692v2.982h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.677v3h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.661v3.014h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.645v3.03h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.629v3.046h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.613v3.062h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.6v3.078h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.581v3.094h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.565v3.11h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.549v3.126h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.533v3.142h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.517v3.158h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.5v3.174h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.485v3.19h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.467,141.469v3.206h-23.96V130.649h23.96Z",
    transform: "translate(-303.204 -131.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.466,139.466v3.222h-23.96V128.661h18.635v-4.58a27.926,27.926,0,0,1,4.433,4.687,17.728,17.728,0,0,1,3.734,10.7Z",
    transform: "translate(-303.204 -129.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.888,139.776a15.367,15.367,0,0,1-.969,5.243v-2.006H302.506V128.988h16.623v-3.827a26.589,26.589,0,0,1,4.211,4.453A16.844,16.844,0,0,1,326.888,139.776Z",
    transform: "translate(-303.204 -129.685)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M324.468,140.087a14.571,14.571,0,0,1-.918,4.967v-1.713H302.506V129.315h14.611v-3.074a25.2,25.2,0,0,1,3.99,4.218A15.957,15.957,0,0,1,324.468,140.087Z",
    transform: "translate(-303.204 -130.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M322.046,140.4a13.76,13.76,0,0,1-.867,4.692v-1.422H302.506V129.642h12.6v-2.321a23.758,23.758,0,0,1,3.769,3.984A15.071,15.071,0,0,1,322.046,140.4Z",
    transform: "translate(-303.204 -130.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M319.626,139.287a12.948,12.948,0,0,1-.816,4.416v-1.13h-16.3V128.547h5.878V123.7C315.367,127.717,319.665,133.23,319.626,139.287Z",
    transform: "translate(-303.204 -129.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M317.205,139.687a13.3,13.3,0,0,1-2.906,7.986v-4.684H302.506V128.962h4.16v-3.886C313.212,128.84,317.243,134.009,317.205,139.687Z",
    transform: "translate(-303.204 -129.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M314.785,140.087a12.411,12.411,0,0,1-2.713,7.453V143.4h-9.566V129.378h2.441V126.45C311.058,129.963,314.819,134.787,314.785,140.087Z",
    transform: "translate(-303.204 -130.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M312.364,140.487a11.531,11.531,0,0,1-2.519,6.921V143.82h-7.339V129.794h.724v-1.97C308.9,131.086,312.4,135.565,312.364,140.487Z",
    transform: "translate(-303.204 -130.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M309.511,140.887a10.635,10.635,0,0,1-2.325,6.389v-3.039h-5.112V130.21l-.994-1.012C306.317,132.209,309.541,136.344,309.511,140.887Z",
    transform: "translate(-302.772 -130.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M306.345,141.286a9.756,9.756,0,0,1-2.131,5.857v-2.491h-2.885V130.625l-2.713-.054C303.417,133.332,306.372,137.122,306.345,141.286Z",
    transform: "translate(-302.026 -131.323)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M303.179,141.686a8.866,8.866,0,0,1-1.937,5.324v-1.942h-.658V131.945h-4.43C300.517,134.455,303.2,137.9,303.179,141.686Z",
    transform: "translate(-301.281 -131.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302,143.8a7.978,7.978,0,0,1-1.744,4.792l1.569-1.394v-8.212h-1.506A7.98,7.98,0,0,1,302,143.8Z",
    transform: "translate(-302.523 -133.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.868v0Z",
    transform: "translate(-303.204 -135.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.845v0Z",
    transform: "translate(-303.204 -135.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.822v0Z",
    transform: "translate(-303.204 -135.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.8v0Z",
    transform: "translate(-303.204 -135.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.776v0Z",
    transform: "translate(-303.204 -135.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.753v0Z",
    transform: "translate(-303.204 -135.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.73v0Z",
    transform: "translate(-303.204 -135.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M302.506,145.707v0Z",
    transform: "translate(-303.204 -135.903)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.962 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 25.236,
    height: 12.003
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.262v2.528H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.246v2.544H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.23v2.56H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.214v2.576H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.2v2.592H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.182v2.608H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.167v2.623H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.151v2.639H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.135v2.655H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.119v2.671H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.1v2.687H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.087v2.7H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.071v2.719H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.055v2.735H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.039v2.751H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.024v2.766H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,141.008v2.782H350.521v-13.4h26.631Z",
    transform: "translate(-351.219 -131.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.152,139.415v2.8H350.521v-13.4h25.755V125.18a32.323,32.323,0,0,1,2.049,4.593h-1.172Z",
    transform: "translate(-351.219 -129.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M377.565,139.568a26.835,26.835,0,0,1-.455,4.743v-1.929H350.521v-13.4h23.45v-3.243a31.379,31.379,0,0,1,1.99,4.462A27.4,27.4,0,0,1,377.565,139.568Z",
    transform: "translate(-351.219 -129.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M375.154,139.722a26.125,26.125,0,0,1-.441,4.6v-1.773H350.521v-13.4h21.145V126.3a30.473,30.473,0,0,1,1.932,4.331A26.591,26.591,0,0,1,375.154,139.722Z",
    transform: "translate(-351.219 -129.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M372.743,139.876a25.228,25.228,0,0,1-.427,4.465v-1.619H350.521v-13.4h18.84v-2.462a29.545,29.545,0,0,1,1.873,4.2A25.77,25.77,0,0,1,372.743,139.876Z",
    transform: "translate(-351.219 -130.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M370.333,140.03a24.514,24.514,0,0,1-.414,4.324v-1.463h-19.4v-13.4h16.535v-2.071a28.682,28.682,0,0,1,1.815,4.068A24.983,24.983,0,0,1,370.333,140.03Z",
    transform: "translate(-351.219 -130.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M367.922,140.183a23.67,23.67,0,0,1-.4,4.185v-1.308h-17v-13.4h14.23v-1.681a27.734,27.734,0,0,1,1.756,3.937A24.17,24.17,0,0,1,367.922,140.183Z",
    transform: "translate(-351.219 -130.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M365.512,140.337a22.883,22.883,0,0,1-.388,4.045V143.23h-14.6v-13.4h11.926v-1.289a26.821,26.821,0,0,1,1.7,3.806A23.362,23.362,0,0,1,365.512,140.337Z",
    transform: "translate(-351.219 -130.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M363.1,138.96a22.556,22.556,0,0,1-1.423,7.695v-4.785H350.521v-13.4h7.374v-4.426A24.72,24.72,0,0,1,363.1,138.96Z",
    transform: "translate(-351.219 -129.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M360.691,139.168a21.769,21.769,0,0,1-1.371,7.42v-4.495h-8.8V128.7h5.149v-3.909A23.834,23.834,0,0,1,360.691,139.168Z",
    transform: "translate(-351.219 -129.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M358.28,139.377a20.953,20.953,0,0,1-1.32,7.145v-4.2h-6.439v-13.4h2.925v-3.392A22.953,22.953,0,0,1,358.28,139.377Z",
    transform: "translate(-351.219 -129.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M355.869,139.585a20.146,20.146,0,0,1-1.269,6.87v-3.914h-4.079v-13.4h.7v-2.875A22.069,22.069,0,0,1,355.869,139.585Z",
    transform: "translate(-351.219 -129.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M352.8,139.793a19.353,19.353,0,0,1-1.219,6.6v-3.623h-1.719v-13.4l-1.524-2.358A21.189,21.189,0,0,1,352.8,139.793Z",
    transform: "translate(-350.557 -130.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M349.421,140a18.531,18.531,0,0,1-1.168,6.321l.641-3.332v-13.4l-3.749-1.842A20.3,20.3,0,0,1,349.421,140Z",
    transform: "translate(-349.592 -130.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.3v0Z",
    transform: "translate(-351.219 -135.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.273v0Z",
    transform: "translate(-351.219 -135.593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.25v0Z",
    transform: "translate(-351.219 -135.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.227v0Z",
    transform: "translate(-351.219 -135.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.2v0Z",
    transform: "translate(-351.219 -135.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.182v0Z",
    transform: "translate(-351.219 -135.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.159v0Z",
    transform: "translate(-351.219 -135.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.136v0Z",
    transform: "translate(-351.219 -135.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.113v0Z",
    transform: "translate(-351.219 -135.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.091v0Z",
    transform: "translate(-351.219 -135.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.068v0Z",
    transform: "translate(-351.219 -135.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.045v0Z",
    transform: "translate(-351.219 -135.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145.022v0Z",
    transform: "translate(-351.219 -135.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,145v0Z",
    transform: "translate(-351.219 -135.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.977v0Z",
    transform: "translate(-351.219 -135.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.954v0Z",
    transform: "translate(-351.219 -135.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.931v0Z",
    transform: "translate(-351.219 -135.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.908v0Z",
    transform: "translate(-351.219 -135.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.886v0Z",
    transform: "translate(-351.219 -135.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.863v0Z",
    transform: "translate(-351.219 -135.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.84v0Z",
    transform: "translate(-351.219 -135.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.521,144.817v0Z",
    transform: "translate(-351.219 -135.455)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.993, 0.122, -0.122, 0.993, 56.134, 90.793)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M0,2.134,26.78,0,36.786,3.458,12.875,8.019Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M13.243,3.605,0,0V22.05l13.243,3.921Z",
    transform: "translate(0 2.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M0,2.281V24.647l23.543-2.5V0Z",
    transform: "translate(13.242 3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M13.546,6.941l-.566-2.8-4.258.571L8.127,0l-4.4.649L4.858,5.233,0,5.885.885,9.817l4.831-1.1L7.017,14l2.8-.633L9.132,7.944Z",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 19.162, 8.819)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.929 12.983) rotate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "matrix(1, 0.02, -0.02, 1, -19.68, -14.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M3.26,2.631A5.964,5.964,0,0,0,2.19,2.3,3.016,3.016,0,0,1,1.31,2a.519.519,0,0,1-.259-.466A.651.651,0,0,1,1.343.966a1.371,1.371,0,0,1,.8-.2,2,2,0,0,1,.7.107,2.494,2.494,0,0,1,.588.329,1.12,1.12,0,0,0,.167.081A.408.408,0,0,0,3.73,1.3a.273.273,0,0,0,.218-.115.419.419,0,0,0,.093-.27A.423.423,0,0,0,4,.721.568.568,0,0,0,3.863.562,2.581,2.581,0,0,0,2.139,0,2.562,2.562,0,0,0,1.1.2,1.709,1.709,0,0,0,.377.77a1.379,1.379,0,0,0-.259.821,1.225,1.225,0,0,0,.207.733A1.5,1.5,0,0,0,.94,2.8,5.326,5.326,0,0,0,2,3.123a3.578,3.578,0,0,1,.9.292.474.474,0,0,1,.27.433.617.617,0,0,1-.289.551,1.516,1.516,0,0,1-.829.189,2.688,2.688,0,0,1-.77-.1,2.2,2.2,0,0,1-.666-.333.6.6,0,0,0-.3-.1.275.275,0,0,0-.218.115.45.45,0,0,0,.078.625A2.36,2.36,0,0,0,1,5.2a3.741,3.741,0,0,0,1.077.152,2.7,2.7,0,0,0,1.062-.2,1.664,1.664,0,0,0,.718-.548,1.344,1.344,0,0,0,.255-.81,1.112,1.112,0,0,0-.218-.7A1.586,1.586,0,0,0,3.26,2.631Z",
    transform: "translate(19.94 14.71) rotate(-1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "aa",
    transform: "matrix(1, 0.02, -0.02, 1, -19.68, -14.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M3.079.3a.478.478,0,0,0-.2-.226.588.588,0,0,0-.585,0,.478.478,0,0,0-.2.226L.045,4.692A.458.458,0,0,0,0,4.884a.363.363,0,0,0,.141.289.469.469,0,0,0,.311.119.434.434,0,0,0,.229-.063.419.419,0,0,0,.163-.2l.444-.992h2.6l.444.992a.409.409,0,0,0,.385.259.465.465,0,0,0,.314-.119.367.367,0,0,0,.137-.289.458.458,0,0,0-.044-.192Zm-1.465,3L2.59,1.1l.977,2.2Z",
    transform: "translate(26.78 14.61) rotate(-1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "z",
    transform: "matrix(1, 0.02, -0.02, 1, -19.68, -14.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M5.024.118A.521.521,0,0,0,4.692,0,.4.4,0,0,0,4.3.252L2.6,4.033.9.252A.417.417,0,0,0,.728.063.454.454,0,0,0,.5,0,.545.545,0,0,0,.152.118.368.368,0,0,0,0,.422.467.467,0,0,0,.044.6L2.086,5.01a.487.487,0,0,0,.2.218.588.588,0,0,0,.585,0,.487.487,0,0,0,.2-.218L5.128.6A.477.477,0,0,0,5.172.414.365.365,0,0,0,5.024.118Z",
    transform: "translate(33.97 14.49) rotate(-1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "y",
    transform: "matrix(1, 0.02, -0.02, 1, -19.68, -14.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M3.13.755a.5.5,0,0,0,.333-.1A.352.352,0,0,0,3.582.37.333.333,0,0,0,3.463.1.515.515,0,0,0,3.13,0H.459A.463.463,0,0,0,.122.119.442.442,0,0,0,0,.452V4.766A.442.442,0,0,0,.122,5.1a.463.463,0,0,0,.337.119H3.13a.516.516,0,0,0,.333-.1.332.332,0,0,0,.118-.274.353.353,0,0,0-.118-.285.5.5,0,0,0-.333-.1H.932V2.938h2.05a.515.515,0,0,0,.333-.1.333.333,0,0,0,.118-.274.341.341,0,0,0-.118-.281.515.515,0,0,0-.333-.1H.932V.755Z",
    transform: "translate(42.06 14.39) rotate(-1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "matrix(1, 0.02, -0.02, 1, -19.68, -14.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M4.888,2.552l-.931.14a3.242,3.242,0,0,1,.054.6,2.2,2.2,0,0,1-.4,1.421,1.364,1.364,0,0,1-1.121.5,1.373,1.373,0,0,1-1.129-.5A2.2,2.2,0,0,1,.955,3.3a2.186,2.186,0,0,1,.4-1.417,1.379,1.379,0,0,1,1.129-.492,1.532,1.532,0,0,1,.686.151l-.4.709.085-.01L4.75,1.953,4.037,0,3.568.834A2.7,2.7,0,0,0,2.486.625,2.6,2.6,0,0,0,1.162.95,2.155,2.155,0,0,0,.3,1.879,3.147,3.147,0,0,0,0,3.3,3.14,3.14,0,0,0,.3,4.717a2.176,2.176,0,0,0,.862.932,2.578,2.578,0,0,0,1.321.326A2.562,2.562,0,0,0,3.8,5.649a2.178,2.178,0,0,0,.862-.932,3.14,3.14,0,0,0,.3-1.421A3.55,3.55,0,0,0,4.888,2.552Z",
    transform: "translate(48.53 13.59) rotate(-1)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.198 406.802) rotate(14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -183.61, -36.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M621.582,480.409,579.3,484.778a2.43,2.43,0,0,1-2.659-2.161l-8.738-84.548a2.429,2.429,0,0,1,2.161-2.659l42.279-4.369a2.43,2.43,0,0,1,2.659,2.161l8.738,84.548A2.43,2.43,0,0,1,621.582,480.409Z",
    transform: "translate(-287.1 -436.93) rotate(14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M828.353,1119.708a1.589,1.589,0,1,0-1.417,1.744A1.589,1.589,0,0,0,828.353,1119.708Z",
    transform: "translate(-793.951 -1032.212)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 41.55,
    height: 79.218,
    rx: 1,
    transform: "translate(2.882 7.082) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 38.376,
    height: 11.411,
    transform: "translate(10.715 68.978) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.15 69.693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M770.12,1038.287l20.21-2.089a.427.427,0,0,0-.088-.85l-20.21,2.089a.428.428,0,0,0-.381.469h0A.428.428,0,0,0,770.12,1038.287Z",
    transform: "translate(-769.649 -1035.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M792.387,1051.944a.428.428,0,0,0-.469-.381l-20.21,2.089a.427.427,0,0,0,.088.85l20.209-2.089A.428.428,0,0,0,792.387,1051.944Z",
    transform: "translate(-771.133 -1049.699)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M701.732,1024.985a2.446,2.446,0,0,0-.212-.8,2.846,2.846,0,0,0-2.951-1.775,2.883,2.883,0,0,0-2.538,2.338,3.133,3.133,0,0,0-.037.838c.162,1.575,3.4,4.8,3.4,4.8S701.894,1026.572,701.732,1024.985Zm-2.738,1.612a1.346,1.346,0,0,1-1.475-1.2,1.413,1.413,0,0,1,.175-.825,1.363,1.363,0,0,1,1.025-.662,1.308,1.308,0,0,1,1.137.437,1.342,1.342,0,0,1-.862,2.25Z",
    transform: "translate(-681.279 -953.196)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.816 20.245) rotate(-7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M0,1.2,15.073,0,20.7,1.946,7.247,4.514Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M7.454,2.029,0,0V12.411l7.454,2.207Z",
    transform: "translate(0 1.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M0,1.284V13.872l13.251-1.408V0Z",
    transform: "translate(7.453 1.948)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.625,3.906,7.306,2.332l-2.4.321L4.574,0,2.1.365l.635,2.58L0,3.312.5,5.526l2.719-.618.732,2.974,1.576-.356L5.14,4.471Z",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 10.785, 4.964)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.753 44.465)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.087)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M675.761,784.517a4.981,4.981,0,0,0-.7-.374,4.8,4.8,0,0,0-2.179-.3,4.5,4.5,0,0,0-3.819,3.14,4.216,4.216,0,0,0-.187,1.8,4.513,4.513,0,0,0,4.943,4.006,4.147,4.147,0,0,0,2.577-1.195,4.36,4.36,0,0,0,1.428-3.749A4.457,4.457,0,0,0,675.761,784.517Zm.187,6.818a3.927,3.927,0,0,1-2.179.937,3.972,3.972,0,0,1-4.357-3.537,3.8,3.8,0,0,1,.141-1.453,3.9,3.9,0,0,1,3.4-2.928,3.5,3.5,0,0,1,1.85.281,3.016,3.016,0,0,1,.773.4,3.969,3.969,0,0,1,.375,6.3Z",
    transform: "translate(-668.847 -783.818)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M677.7,771.36l2.85,4.434,3.818-10.975-4.151,7.747Z",
    transform: "translate(-675.795 -764.819)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.84 4.229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M760.069,768.619l-22.608,2.336a.42.42,0,0,1-.459-.373l-.009-.092a.42.42,0,0,1,.373-.459l22.607-2.336a.42.42,0,0,1,.459.373l.009.092A.42.42,0,0,1,760.069,768.619Z",
    transform: "translate(-736.991 -767.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M761.551,782.96,738.944,785.3a.42.42,0,0,1-.46-.373l-.009-.092a.42.42,0,0,1,.373-.459l22.607-2.337a.42.42,0,0,1,.459.373l.01.092A.42.42,0,0,1,761.551,782.96Z",
    transform: "translate(-738.303 -780.387)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.d7ae4ea1d4c9142cd17883b28ba61afc.svg";
export { ForwardRef as ReactComponent };